// extracted by mini-css-extract-plugin
export default {"successText":"udxccEynIht9g6THRNVc","warningText":"dvJFwJWQbcAuHwpQrLoX","pendingText":"mO5L7vw40tg0xAUMlUZL"};